module.exports = __webpack_public_path__ + "static/media/stripe_logo.13513a45.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stripe_logo.svg
// module id = 800
// module chunks = 0